import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2500ffa0&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=2500ffa0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2500ffa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2500ffa0')) {
      api.createRecord('2500ffa0', component.options)
    } else {
      api.reload('2500ffa0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2500ffa0&scoped=true", function () {
      api.rerender('2500ffa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Inr/index.vue"
export default component.exports